/* eslint-disable react-hooks/exhaustive-deps */
import { alpha, Backdrop, Box, Button, CircularProgress, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import RoleService from "../../../services/roleService";
import { useTheme } from "@emotion/react";


const ViewRoleModal = ({ open,
    handleClose,
    roleId }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [role, setRole] = useState({});
    const [isModalLoading, setIsModalLoading] = useState(true);

    const fetchRole = async () => {
        try {
            const data = await RoleService.fetchOne(roleId);
            setRole(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching permissions:', error);
        }
    };

    useEffect(() => {
        setIsModalLoading(true);
        if (open) {
            fetchRole();
        }
    }, [open]);


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '80%' : '40%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isMobile ? 1 : 4,
                          height: '80vh',
                        overflowY: 'scroll'
                    }}
                >
                    {isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>

                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('roleInfo')}
                                </Typography>
                                <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                            </Box>

                            <Typography variant="body1" sx={{ mt: 2 }}>
                                {t('name')}: <span style={{ fontWeight: 'bold' }}>{role.name}</span>
                            </Typography>

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                <Typography variant="body1" sx={{ mt: 1 }}>
                                    {t('superAdmin')}:
                                </Typography>
                                <Box
                                    sx={{
                                        bgcolor: alpha(
                                            role.superAdmin ? theme.palette.green.box : theme.palette.purple.box, 0.2),
                                        width: 80,
                                        justifyContent: 'center',
                                        display: 'flex',
                                        py: 0.2,
                                        borderRadius: 0.8,
                                        mt: 1,
                                        mx: 1
                                    }}
                                >
                                    <Box
                                        sx={{
                                            fontWeight: 'bold',
                                            color: role.superAdmin ? theme.palette.green.box : theme.palette.purple.box,
                                        }}
                                    >
                                        {role.superAdmin ? t('yes') : t('no')}
                                    </Box>
                                </Box>
                            </Box>


                            <Typography variant="body1" sx={{ mt: 1 }}>
                                {t('createdAt')}: <span style={{ fontWeight: 'bold' }}>{role.createdAt}</span>
                            </Typography>

                            <Typography variant="body1" sx={{ mt: 1 }}>
                                {t('permissions')}:
                            </Typography>

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                                    gap: 2,
                                    mt: 2,
                                }}
                            >
                                {role.rolePermissions.map((permission) => (
                                    <Box
                                        key={permission.id}
                                        sx={{
                                            border: `1px solid ${theme.palette.primary.main}`,
                                            borderRadius: 0.8,
                                            p: 1,
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            color: theme.palette.text.primary,
                                        }}
                                    >
                                        {t(permission.name)}
                                    </Box>
                                ))}
                            </Box>


                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 2
                            }}>
                                {/* close */}
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={handleClose}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('close')}</p>
                                        <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>

                                <Box width={20}></Box>

                            </Box>
                        </Box>
                    }
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewRoleModal;
